/* globals $:true */
SP.lang.Class.define("SP.form.DisplayCondition", {

	el: null,

	init: function (el, options) {
		this._el = el;

		if (options.field) {
			var field = document.querySelector("#" + options.field);
			this.toggle(field);

			field.addEventListener("change", function (e) {
				this.toggle(e.target);
			}.bind(this));
		}
	},

	toggle: function (trigger) {
		if (trigger.checked) {
			this._el.setAttribute("aria-hidden", false);
			trigger.setAttribute("aria-expanded", true);

			if (typeof $ ===  "function") {
				$(this._el).slideDown(400, function() {
					this._el.removeAttribute("hidden");
					this._el.style.display = "block";
				}.bind(this));
			} else {
				this._el.removeAttribute("hidden");
				this._el.style.display = "block";
			}
		} else {
			this._el.setAttribute("aria-hidden", true);
			this._el.setAttribute("hidden", true);

			if (typeof $ ===  "function") {
				$(this._el).slideUp(400, function() {
					this._el.setAttribute("hidden", true);
					this._el.style.display = "none";
				}.bind(this));
			} else {
				this._el.setAttribute("hidden", true);
				this._el.style.display = "none";
			}
		}
	}

});
